import * as React from 'react';
import './App.css';
import Button from '@mui/material/Button';
import IconoCalendario from "./logos/calendario_icon.svg"
import IconoHerramientas from "./logos/herramientas_icon.svg"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TurnoPDF from './components/TurnoPDF';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const theme = createTheme({
    palette: {
      colorMVL: {
        light: '#ab3897',
        main: '#97077D',
        dark: '#690457',
        contrastText: '#fff',
      },
      guia: {
        light: '#ffffff',
        main: '#ffffff',
        dark: '#b2b2b2',
        contrastText: '#a4258d',
      },
    },
  });
  


export default function Lobby() {


    return(
        <div>
            <p className='lobby-titulo'>SISTEMA DE GESTIÓN DE TURNOS</p>
            <p className='lobby-texto'>Te presentamos el nuevo sistema de solicitud y gestión de turnos de la Municipalidad de Vicente López.</p>
        
            <div className='box-container'>
                <div className='lobby-box'>
                    <div className='cabezal'>
                        <img src={IconoCalendario} className='svg-lobby' />
                        <p className='titulo'>  NUEVO TURNO</p>
                    </div>
                    <p>Para solicitar un nuevo turno puedes ingresar desde acá.</p>

                    <ThemeProvider theme={theme}>
                        <Button color='colorMVL' variant='contained' href='./formTurno' className='boton' endIcon={<AddCircleOutlineIcon />}>Solicitar turno</Button>
                    </ThemeProvider>
                </div>
            </div>
            
            <div className='box-container'>
                <div className='lobby-box'>
                    <div className='cabezal'>
                        <img src={IconoHerramientas} className='svg-lobby' />
                        <p className='titulo'>  GESTIONAR TURNO</p>
                    </div>
                    <p>Accede a esta opción si deseas consultar o cancelar un turno.</p>

                    <ThemeProvider theme={theme}>
                        <Button color='colorMVL' variant='contained' href='./gestiones' className='boton' endIcon={<SettingsOutlinedIcon />}>GESTIONAR TURNO</Button>
                    </ThemeProvider>
                </div>
            </div>

            <ThemeProvider theme={theme}>
                <Button color='guia' variant='contained' href='./uso' style={{"fontWeight": "bold", "border": "1px solid #a4258d"}} endIcon={<ErrorOutlineIcon />} >Guía de uso</Button>
            </ThemeProvider>
        </div>
    )
}